<template>
  <div class="app-detail-skeleton">
    <!-- Navbar Skeleton -->
    <div class="skeleton-navbar">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-3">
            <div class="skeleton-logo"></div>
          </div>
          <div class="col-lg-6">
            <div class="skeleton-nav-links">
              <div class="skeleton-nav-item"></div>
              <div class="skeleton-nav-item"></div>
              <div class="skeleton-nav-item"></div>
              <div class="skeleton-nav-item"></div>
              <div class="skeleton-nav-item"></div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="skeleton-nav-buttons">
              <div class="skeleton-nav-button"></div>
              <div class="skeleton-nav-button"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Banner Skeleton -->
    <div class="skeleton-banner">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5 col-md-12">
            <div class="skeleton-banner-content">
              <div class="skeleton-subtitle"></div>
              <div class="skeleton-title"></div>
              <div class="skeleton-description"></div>
              <div class="skeleton-buttons">
                <div class="skeleton-button"></div>
                <div class="skeleton-button"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-12">
            <div class="skeleton-banner-image">
              <div class="skeleton-image"></div>
              <div class="skeleton-image-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Features Section Skeleton -->
    <div class="skeleton-features">
      <div class="container">
        <div class="skeleton-section-title"></div>
        <div class="row">
          <div class="col-lg-4 col-md-6" v-for="n in 3" :key="n">
            <div class="skeleton-feature-card">
              <div class="skeleton-feature-icon"></div>
              <div class="skeleton-feature-title"></div>
              <div class="skeleton-feature-text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDetailSkeleton'
}
</script>

<style scoped>
.app-detail-skeleton {
  background: #fff;
}

.skeleton-banner {
  z-index: 1;
  padding: 80px 0;
  position: relative;
  border-bottom: 1px solid #eeeeee;
}

.skeleton-banner-content {
  padding-right: 15px;
}

.skeleton-subtitle {
  display: block;
  width: 120px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
  border-left: 2px solid #ED2775;
  padding-left: 10px;
}

.skeleton-title {
  width: 80%;
  height: 48px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 18px;
}

.skeleton-description {
  width: 100%;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-description:last-of-type {
  width: 70%;
}

.skeleton-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.skeleton-button {
  width: 140px;
  height: 45px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 25px;
}

.skeleton-banner-image {
  text-align: end;
  margin-left: 15px;
  position: relative;
}

.skeleton-image {
  width: 100%;
  height: 400px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 12px;
  max-width: 500px;
  margin: 0 auto;
}

.skeleton-image-overlay {
  position: absolute;
  z-index: -1;
  bottom: 0;
  left: 0;
  width: 80%;
  height: 350px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 12px;
}

.skeleton-features {
  padding: 80px 0;
}

.skeleton-section-title {
  width: 300px;
  height: 40px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 8px;
  margin: 0 auto 50px;
}

.skeleton-feature-card {
  text-align: center;
  padding: 30px 20px;
  background: #f9f9f9;
  border-radius: 12px;
  margin-bottom: 30px;
  transition: transform 0.3s ease;
}

.skeleton-feature-card:hover {
  transform: translateY(-5px);
}

.skeleton-feature-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 50%;
  margin: 0 auto 20px;
}

.skeleton-feature-title {
  width: 80%;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin: 0 auto 15px;
}

.skeleton-feature-text {
  width: 90%;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin: 0 auto 10px;
}

.skeleton-feature-text:last-child {
  width: 70%;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 768px) {
  .skeleton-banner {
    padding: 60px 0;
  }
  
  .skeleton-banner-content {
    padding-right: 0;
    text-align: center;
    margin-bottom: 30px;
  }
  
  .skeleton-subtitle {
    display: inline-block;
    margin-bottom: 14px;
  }
  
  .skeleton-title {
    font-size: 45px;
  }
  
  .skeleton-buttons {
    justify-content: center;
  }
  
  .skeleton-banner-image {
    text-align: center;
    margin-left: 0;
  }
  
  .skeleton-image {
    height: 300px;
  }
  
  .skeleton-features {
    padding: 60px 0;
  }
}

@media (max-width: 767px) { 
.skeleton-image {
    height: 100vh;
}
}
</style> 